import { EvaluateCriteria } from '@/plugins/api'

export default {
  namespaced: true,

  state: {
    evaluateCriterias: [],
    totalEvaluateCriterias: 0,
    currentEvaluateCriteria: null,
  },

  mutations: {
    SET_EVALUATE_CRITERIAS(state, evaluateCriterias) {
      state.evaluateCriterias = evaluateCriterias
    },
    SET_TOTAL_EVALUATE_CRITERIAS(state, total) {
      state.totalEvaluateCriterias = total
    },
    SET_CURRENT_EVALUATE_CRITERIA(state, evaluateCriteria) {
      state.currentEvaluateCriteria = evaluateCriteria
    },
    ADD_EVALUATE_CRITERIA(state, evaluateCriteria) {
      if (Array.isArray(state.evaluateCriterias)) {
        state.evaluateCriterias.push(evaluateCriteria)
      } else {
        state.evaluateCriterias = [evaluateCriteria]
      }
    },
    UPDATE_EVALUATE_CRITERIA(state, updatedEvaluateCriteria) {
      const index = state.evaluateCriterias.findIndex((ec) => ec.id === updatedEvaluateCriteria.id)
      if (index !== -1) {
        state.evaluateCriterias.splice(index, 1, updatedEvaluateCriteria)
      }
    },
    REMOVE_EVALUATE_CRITERIA(state, id) {
      state.evaluateCriterias = state.evaluateCriterias.filter((ec) => ec.id !== id)
    },
  },

  actions: {
    async fetchEvaluateCriterias({ commit }, params) {
      try {
        const response = await EvaluateCriteria.fetch(params)
        commit('SET_EVALUATE_CRITERIAS', response)
        const countResponse = await EvaluateCriteria.count(params)
        commit('SET_TOTAL_EVALUATE_CRITERIAS', countResponse)
      } catch (error) {
        console.error('Error fetching evaluate criterias:', error)
        throw error
      }
    },

    async fetchEvaluateCriteria({ commit }, id) {
      try {
        const response = await EvaluateCriteria.fetchOne(id)
        commit('SET_CURRENT_EVALUATE_CRITERIA', response)
        return response
      } catch (error) {
        console.error('Error fetching evaluate criteria:', error)
        throw error
      }
    },

    async createEvaluateCriteria({ commit }, evaluateCriteria) {
      try {
        const response = await EvaluateCriteria.create(evaluateCriteria)
        commit('ADD_EVALUATE_CRITERIA', response)
        return response
      } catch (error) {
        console.error('Error creating evaluate criteria:', error)
        throw error
      }
    },

    async updateEvaluateCriteria({ commit }, { id, data }) {
      try {
        const response = await EvaluateCriteria.update(id, data)
        commit('UPDATE_EVALUATE_CRITERIA', response)
        return response
      } catch (error) {
        console.error('Error updating evaluate criteria:', error)
        throw error
      }
    },

    async deleteEvaluateCriteria({ commit }, id) {
      try {
        await EvaluateCriteria.remove(id)
        commit('REMOVE_EVALUATE_CRITERIA', id)
      } catch (error) {
        console.error('Error deleting evaluate criteria:', error)
        throw error
      }
    },
  },

  getters: {
    getEvaluateCriterias: (state) => state.evaluateCriterias,
    getTotalEvaluateCriterias: (state) => state.totalEvaluateCriterias,
    getCurrentEvaluateCriteria: (state) => state.currentEvaluateCriteria,
  },
}
